import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initializeScale } from '@cloudorder/ui';

import { App } from '@/app/App';

/* Scale is initialised exactly once, before the first render, so the design
   tokens and colour scheme are in place before any component measures itself.

   i18next is initialised the same way, by importing its configuration for the
   side effect. Both catalogues are bundled, so this completes synchronously and
   no component can mount against an uninitialised instance — which is why the
   import sits here rather than inside a provider. */
import '@/shared/i18n/config';

initializeScale();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element — index.html and main.tsx are out of step.');
}

/* Rendered synchronously. There is no identity client to initialise and no
   redirect fragment to consume before React starts: the sign-in happens in the
   Python service and reaches the browser as a plain navigation carrying a
   cookie. `AuthProvider` asks `/auth/me` who that cookie belongs to once it is
   mounted, and `AuthGuard` waits on the answer. */
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
